const skillsSuggestions = [
  'Pływanie',
  'Prowadzenie',
  'Śpiewanie',
  'Przemowy',
  'Zarządzanie',
  'Prawo jazdy kat. b',
  'Strzelanie',
  'Zdolności manualne',
  'Komunikatywność',
  'Programowanie',
  'Siła',
  'Bieganie',
]

export default skillsSuggestions